import { DataPoint, TableWidget } from '@revolut-internal/ui-kit'

export const InboxesSummary = () => {
  return (
    <TableWidget.Info>
      <DataPoint>
        <DataPoint.Value use="h3" color="grey-tone-50">
          0
        </DataPoint.Value>
        <DataPoint.Label>Active</DataPoint.Label>
      </DataPoint>
    </TableWidget.Info>
  )
}
